import http from "../../Services/Auth/config/http-common";
import ICatUsuarios from "../../Interfaces/Catalogos/ICatUsuarios";
import IRespuesta from "../../Interfaces/Respuestas/IRespuesta";
import IAuth from "../../Interfaces/Auth/IAuth";

class CatUsuariosDataService {
  async GetAll() {
    return await http.get<ICatUsuarios[]>("Catalogos/Usuarios/GetAll");
  }
  Append(data: ICatUsuarios) {
    return http.post<ICatUsuarios>(`Catalogos/Usuarios/Append`,data);
  }  
  Delete(id: number) {
    return http.delete<IRespuesta>(`Catalogos/Usuarios/Delete/${id}`);
  }
}
export default new CatUsuariosDataService();